import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import { history } from '../../../store';

import throttle from 'lodash/throttle';

import isLoggedIn, {isGM, isSA} from '../../../utils/auth';
import {formatFluorescence, formatNumber, formatCarat, formatShape, formatPrice, formatCost, formatCut, formatColor, formatClarity, formatPolish, formatLocation, getLocationId, formatDepth, formatJewelryType} from '../../../utils/formatting';

import * as holdConst from '../../../constants/hold';
import * as api from '../../../constants/api';

import RhinoModal from '../../common/modal/RhinoModal';
import RhinoSelect from '../../common/inputs/RhinoSelect';
import RhinoLoading from '../common/RhinoLoading';

import * as authActionCreators from '../../../actions/auth';
import * as commonActionCreators from '../../../actions/common';
import * as jewelryActionCreators from '../../../actions/jewelry';
import * as leadsActionCreators from '../../../actions/leads';
import * as messagesActionCreators from '../../../actions/messages';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, authActionCreators, commonActionCreators, jewelryActionCreators, leadsActionCreators, messagesActionCreators, usersActionCreators);

class JewelryResults extends React.Component {


  constructor(props) {
    super(props);

    let sortByOptions = [
      { display: 'Sort By', value: '' },
      { display: 'Price', value: 'sell_price' },
      // { display: 'Location', value: 'location' },
    ];

    let actionsOptions = [
      { display: 'Actions', value: '' },
      { display: 'Show Only Selected', value: 'showOnly' },
      // { display: 'Add to My Profile', value: 'profile' },
      // { display: 'Share All', value: 'share' },
      { display: 'Uncheck All', value: 'uncheck' },
    ];

    this.PRICE_MIN = 0;
    this.PRICE_MAX = 1000000;
    this.COST_MIN = 0;
    this.COST_MAX = 1000000;
    this.DIAMOND_TCW_MIN = 0;
    this.DIAMOND_TCW_MAX = 1000000;
    this.GEMSTONE_TCW_MIN = 0;
    this.GEMSTONE_TCW_MAX = 1000000;


    this.state = {

      selectedJewelry: this.props.jewelry.selectedList,
      expandedIndividualShares: [],
      showOnlySelected: false,

      sortByOpen: false,
      sortByDisplay: 'Price',
      sortByValue: null,

      sortByExtensionOpen: false,
      sortByExtensionDisplay: null,
      sortByExtensionValue: null,

      locations: this.props.jewelry.jewelryFilter.locations ? this.props.jewelry.jewelryFilter.locations : '',

      actionsOpen: false,
      shareAllOpen: false,

      transferModalOpen: false,
      transferMessage: '',
      transferName: '',
      transferApptDate: '',
      transferApptTime: '',
      transferBudget: '',

      transferApptDateError: '',

      holdModalOpen: false,
      holdMessage: '',

      shareModalOpen: false,

      currentPage: 1,
      defaultResults: 100,
      lastPage: false,
      requestPending: true,

      locationData: null,

      resultsBlocked: false,
      windowWidth: window.innerWidth,
    }

    // Load jewelry based on filters
    // if(this.props.jewelry.jewelryResults == null) {

      this.props.fetchJewelry(this.setJewelryFilters(this.props.jewelry.jewelryFilter), 1)
      .then((respData) => {
        if(respData === null) {
          this.setState({ resultsBlocked: true });
        } else {

          this.setState({ 
            requestPending: false,
            lastPage: parseInt(respData.count) < this.state.defaultResults,
          });

          this.props.jewelrySave(respData.products, respData.count);
        }
      });
    // }

    // Load locations based on filters
    // if(this.state.locationData == null) {

    //   this.props.fetchLocationData(this.props.jewelry.jewelryFilter)
    //   .then((respData) => {
    //     this.setState({ locationData: respData.locations });
    //   })
    //   // .catch((errorResp) => {
    //   //   this.setState({ requestPending: false });
    //   //   console.error(errorResp);
    //   // });      
    // }

    // Bind event listeners
    this.checkSortBy = this.checkSortBy.bind(this);
    this.checkSortByExtension = this.checkSortByExtension.bind(this);
    this.checkActions = this.checkActions.bind(this);
    this.getScrollPercentage = this.getScrollPercentage.bind(this);
    this.setWindowWidth = this.setWindowWidth.bind(this);

    this.scrollThrottle = throttle(this.getScrollPercentage, 100, { 'leading': true, 'trailing': false });
  }

  componentDidMount() {
    let intId = setInterval(this.getScrollPercentage, 1000);

    if(this.props.jewelry.lastResultsPosition) {
      this.props.commonScrollTo(this.props.jewelry.lastResultsPosition);
      this.props.jewelrySetLastPosition(0);
    }
  }

  componentWillMount() {
    document.addEventListener('click', this.checkSortBy, false);
    document.addEventListener('click', this.checkSortByExtension, false);
    document.addEventListener('click', this.checkActions, false);
    window.addEventListener('scroll', this.getScrollPercentage, false);
    window.addEventListener('resize', this.setWindowWidth, false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.checkSortBy, false);
    document.removeEventListener('click', this.checkSortByExtension, false);
    document.removeEventListener('click', this.checkActions, false);
    window.removeEventListener('scroll', this.scrollThrottle, false);
    window.removeEventListener('resize', this.setWindowWidth, false);
  }

  setWindowWidth() {
    this.setState({ windowWidth: window.innerWidth });
  }

  createList(optionsArray) {

    let first = true;
    let optionList = '';

    if(optionsArray.length === 0) {
      return 'All';
    }

    for(let i = 0; i < optionsArray.length; i++) {
      if(first) {
        optionList = optionsArray[i];
      } else {
        optionList += ',' + optionsArray[i];
      }
      first = false;
    }
    return optionList;
  }

  getMaxValue(filterValues, filterOptions) {

    if(filterValues == 'All') {
      return this.getMaxPossible(filterOptions);
    }

    for(let i = 0; i < filterOptions.length; i++) {
      if(filterValues.includes(filterOptions[i])) {
        return filterOptions[i];
      }
    }
    return '';
  }

  getMaxPossible(filterOptions) {
    return filterOptions[0];
  }

  getMinValue(filterValues, filterOptions) {

    if(filterValues == 'All') {
      return this.getMinPossible(filterOptions);
    }

    for(let i = filterOptions.length - 1; i >= 0; i--) {
      if(filterValues.includes(filterOptions[i])) {
        return filterOptions[i];
      }
    }
    return '';
  }

  getMinPossible(filterOptions) {
    return filterOptions[filterOptions.length - 1];
  }

  setJewelryFilters() {

    const jewelryKeys = [
      "type",
      "gemstoneType",
      "style",
      "designers",
      "price_min",
      "price_max",
      "diamond_min",
      "diamond_max",
      "gemstone_min",
      "gemstone_max",
      "search_term",
    ];

    const reqFilters = {};
    for(const key of jewelryKeys) {
      switch(key) {
        case 'type':
          if(this.props.jewelry.jewelryFilter.jewelryType && this.props.jewelry.jewelryFilter.jewelryType !== 'All') {
            reqFilters[key] = this.props.jewelry.jewelryFilter.jewelryType ? this.props.jewelry.jewelryFilter.jewelryType : '';
          }
          break;
        case 'gemstoneType':
          if(this.props.jewelry.jewelryFilter.gemstoneType && this.props.jewelry.jewelryFilter.gemstoneType !== 'All') {
            reqFilters[key] = this.props.jewelry.jewelryFilter.gemstoneType ? this.props.jewelry.jewelryFilter.gemstoneType : '';
          }
          break;
        case 'style':
          if(this.props.jewelry.jewelryFilter.style && this.props.jewelry.jewelryFilter.style !== 'All') {
            reqFilters[key] = this.props.jewelry.jewelryFilter.style ? this.props.jewelry.jewelryFilter.style : '';
          }
          break;
        case 'designers':
          if(this.props.jewelry.jewelryFilter.designers && this.props.jewelry.jewelryFilter.designers !== 'All') {
            reqFilters[key] = this.props.jewelry.jewelryFilter.designers ? this.props.jewelry.jewelryFilter.designers : '';
          }
          break;
        case 'price_min':
          reqFilters[key] = this.props.jewelry.jewelryFilter.price_min ? this.props.jewelry.jewelryFilter.price_min : this.PRICE_MIN;
          break;
        case 'price_max':
          reqFilters[key] = this.props.jewelry.jewelryFilter.price_max ? this.props.jewelry.jewelryFilter.price_max : this.PRICE_MAX;
          break;
        case 'diamond_min':
          if(this.props.jewelry.jewelryFilter.diamond_min) {
            reqFilters[key] = this.props.jewelry.jewelryFilter.diamond_min;
          }
          break;
        case 'diamond_max':
          if(this.props.jewelry.jewelryFilter.diamond_max) {
            reqFilters[key] = this.props.jewelry.jewelryFilter.diamond_max;
          }
          break;
        case 'gemstone_min':
          if(this.props.jewelry.jewelryFilter.gemstone_min) {
            reqFilters[key] = this.props.jewelry.jewelryFilter.gemstone_min;
          }
          break;
        case 'gemstone_max':
          if(this.props.jewelry.jewelryFilter.gemstone_max) {
            reqFilters[key] = this.props.jewelry.jewelryFilter.gemstone_max;
          }
          break;
        case 'sort':
          if(this.props.jewelry.jewelryFilter.sort) {
            reqFilters[key] = this.props.jewelry.jewelryFilter.sort;
          }
          break;
        case 'search_term':
          if(this.props.jewelry.jewelryFilter.search_term) {
            reqFilters[key] = this.props.jewelry.jewelryFilter.search_term;
          }
        default:
          break;
      }
    }
    return reqFilters;
  }

  checkSortBy(evt) {

    if(this.state.sortByOpen === true) {
      let targetElement = evt.target;

      do {
          if (targetElement == this.sortByMenuBody || targetElement == this.sortByLabel || targetElement == this.sortByArrow || targetElement == this.sortByDisplay) {
              return;
          }
          targetElement = targetElement.parentNode;
      } while (targetElement);

      // This is a click outside, should close
      this.setState({ sortByOpen: false });
    }
  }

  checkSortByExtension(evt) {
    
    if(this.state.sortByExtensionOpen === true) {
      let targetElement = evt.target;

      do {
          if (targetElement == this.sortByExtensionMenuBody || targetElement == this.sortByLabel || targetElement == this.sortByArrow || targetElement == this.sortByExtensionDisplay) {
              return;
          }
          targetElement = targetElement.parentNode;
      } while (targetElement);

      // This is a click outside, should close
      this.setState({ sortByExtensionOpen: false });
    }
  }

  checkActions(evt) {
    
    if(this.state.actionsOpen === true) {
      let targetElement = evt.target;

      do {
          if (targetElement == this.actionsMenuBody || targetElement == this.actionsLabel || targetElement == this.actionsArrow) {
              return;
          }
          targetElement = targetElement.parentNode;
      } while (targetElement);

      // This is a click outside, should close
      this.setState({ actionsOpen: false });
    }
  }

  getScrollPercentage() {
    if(this.resultsWrapper) {
      let percent = this.props.common.currentScrollTop / (this.resultsWrapper.offsetHeight);
      if(percent > 0.8) {
        this.appendSearch();
      }
    }
  }

  resetSearch() {
    this.props.jewelrySave(null);
    this.setState({
      requestPending: true,
      resultsBlocked: false,
    }, () => {
      setTimeout(() => {

        this.props.fetchJewelry(this.setJewelryFilters(this.props.jewelry.jewelryFilter), 1)
        .then((respData) => {
          if(respData === null) {
            this.setState({ resultsBlocked: true });
          } else {
            this.setState({ 
              requestPending: false,
              lastPage: parseInt(respData.count) < this.state.defaultResults,
            });
            this.props.jewelrySave(respData.products, respData.count);
          }          
        })
        
      }, 50);
    });
  }

  appendSearch() {
    if(!this.state.requestPending && !this.state.lastPage) {
      this.setState({
        // requestPending: true,
        currentPage: this.state.currentPage + 1,
      }, () => {

          this.props.fetchJewelry(this.setJewelryFilters(this.props.jewelry.jewelryFilter), this.state.currentPage)
          .then((respData) => {
            if(respData === null) {
              this.setState({ resultsBlocked: true });
            } else {
              this.setState({ 
                requestPending: false,
                lastPage: parseInt(respData.count) < this.state.defaultResults,
              });

              const existingJewelry = this.cloneArray(this.props.jewelry.jewelryResults);
              const appendedJewelry = existingJewelry.concat(respData.products);

              this.props.jewelrySave(appendedJewelry, respData.count);
            }
          });

        
      });
    }
  }

  addSort(value) {

    let currentSort = this.props.jewelry.jewelryFilter.sort;

    if(!currentSort) {
      currentSort = '';
    }

    let sortParam = '';

    if(value == 'Price') {
      sortParam = 'price';
    } else if(value == 'Cost') {
      sortParam = 'cost';
    } else if(value == 'Location') {
      sortParam = 'location_name';
    } else if(value == null) {
      sortParam = '';
    }

    const sortObj = {
      sort: sortParam,
      locations: this.state.locations,
    };

    let newFilter = Object.assign({}, this.props.jewelry.jewelryFilter, sortObj);

    this.props.setJewelryFilters(newFilter);

    if(currentSort != sortParam) {
      this.resetSearch();
    }
  }

  addLocations() {
    
    let currentLocation = this.props.jewelry.jewelryFilter.location;

    if(!currentLocation) {
      currentLocation = 'All';
    }

    let newFilter = Object.assign({}, this.props.jewelry.jewelryFilter, {
      locations: this.state.locations,
    });

    this.props.setJewelryFilters(newFilter);

    // if(currentLocation != location_id) {
    this.resetSearch();
    // }
  }

  uncheckAll() {
    this.setState({ selectedJewelry: [] }, () => {
      this.props.jewelrySaveSelected(this.state.selectedJewelry);
    });
  }

  toggleSortByMenu() {
    this.setState({ sortByOpen: !this.state.sortByOpen });
  }

  toggleSortByExtensionMenu() {
    this.setState({ sortByExtensionOpen: !this.state.sortByExtensionOpen }); 
  }

  toggleSortArrow() {
    if(this.state.sortByDisplay == 'Location') {
      this.setState({ sortByExtensionOpen: !this.state.sortByExtensionOpen }); 
    } else {
      this.setState({ sortByOpen: !this.state.sortByOpen });
    }
  }

  toggleActionsMenu() {
    this.setState({ actionsOpen: !this.state.actionsOpen });
  }

  selectSort(displayValue) {

    let currentSort = this.state.sortByDisplay;

    if(displayValue == 'Location') {
      this.setState({
        sortByExtensionOpen: true,
      });
      return;
    }

    if(this.state.sortByDisplay != displayValue) {
      this.setState({ sortByDisplay: displayValue }, () => {
        this.addSort(displayValue);
      });
    } else {

      // Do nothing; a sort value will always be selected
      // this.setState({ sortByDisplay: null }, () => {
        // this.addSort('');
      // });
    }

    if(displayValue != 'Location') {
      this.setState({ sortByExtensionDisplay: null });
    }
  }

  getDefaultImage() {    
    return '/img/watches/watch_icon.svg';
  }

  cloneArray(source) {
    let result = [];
    for(let n = 0; n < source.length; n++) {
      result[n] = source[n];
    }
    return result;
  }

  userNav(page) {
    history.push('/' + page);
  }

  watchesNav() {
    this.props.setJewelryFilters({});
    history.push('/jewelry');
  }

  editNav() {
    history.push('/jewelry');
  }

  toggleSelected(watch) {

    let clone = this.cloneArray(this.state.selectedJewelry);
    let i = this.state.selectedJewelry.indexOf(watch.sku);
    if(i > -1) {
      clone.splice(i, 1);
    } else {
      clone.push(watch.sku);
    }

    this.setState({
      selectedJewelry: clone,
    }, () => {
      this.props.jewelrySaveSelected(this.state.selectedJewelry);
    });
  }

  isSelected(jewelry) {
    if(!jewelry) { return null; }
    return this.state.selectedJewelry.indexOf(jewelry.sku) > -1;
  }

  toggleIndividualShare(watch) {

    let clone = this.cloneArray(this.state.expandedIndividualShares);
    let i = this.state.expandedIndividualShares.indexOf(watch.sku);
    if(i > -1) {
      clone.splice(i, 1);
    } else {
      clone.push(watch.sku);
    }

    this.setState({
      expandedIndividualShares: clone,
    });
  }

  individualShareOpen(watch) {
    return this.state.expandedIndividualShares.indexOf(watch.sku) > -1;
  }

  toggleShowOnlySelected() {
    this.setState({ showOnlySelected: !this.state.showOnlySelected });
  }

  getCost(watch) {
    if(!isLoggedIn() || watch.cost === null || watch.cost === 0) {
      return '';
    } else {
      if(this.props.auth.hideData) {
        return '';
      } else {
        return '(' + formatCost(watch) + ')';
      }
    }
  }

  resetFilters() {
    this.setState({
      sortByOpen: false,
      sortByDisplay: 'Price',
      sortByValue: null,
      sortByExtensionOpen: false,
      sortByExtensionDisplay: null,
      sortByExtensionValue: null,
      actionsOpen: false,
    }, () => {
      let newFilter = Object.assign({}, this.props.jewelry.jewelryFilter, {
        sort: 'price',
        location: '',
      });
      this.props.setJewelryFilters(newFilter);
      this.resetSearch();
    })
  }

  shareWatch(watch) {
    if(isLoggedIn()) {
      this.setState({
        selectedJewelry: [ watch.sku ],
      }, () => {
        this.props.jewelrySaveSelected(this.state.selectedJewelry);
        this.props.leadsOpenShareDirectDropdown([watch], 'WATCH');
      });
    }
  }

  holdAll() {

    if(this.state.selectedJewelry.length === 0) {
      this.props.commonAlert('Please select at least one watch');
      return;
    }
    this.setState({ holdModalOpen: true });
  }

  sendHoldRequest() {
    let confirmationMessage = 'Hold requests sent';
    if(this.state.selectedJewelry.length === 1) {
      confirmationMessage = 'Hold request sent';
    }
    this.props.messagesShowConfirmation(confirmationMessage);
    this.setState({
      holdModalOpen: false,
    }, () => {

      let holdData = {
        diamonds: this.state.selectedJewelry,
        message_body: this.state.holdMessage,
      }

      this.props.messagesSendHoldReq(holdData)
      .then((respData) => {
        this.uncheckAll();
      })
      // .catch((errorResp) => {
      //   console.error(errorResp);
      // });
    });
  }

  transferAll() {

    if(this.state.selectedJewelry.length === 0) {
      this.props.commonAlert('Please select at least one diamond');
      return;
    }
    this.setState({ transferModalOpen: true });
  }

  validateTransfer() {
    if(!this.state.transferApptDate) {
      this.setState({
        transferApptDateError: 'Please enter an appointment date',
      });
      return false;
    }
    return true;
  }

  sendTransferRequest() {

    if(this.validateTransfer() === false) {
      return null;
    }

    let confirmationMessage = 'Transfer requests sent';
    if(this.state.selectedJewelry.length === 1) {
      confirmationMessage = 'Transfer request sent';
    }
    this.props.messagesShowConfirmation(confirmationMessage);
    this.setState({
      transferModalOpen: false,
    }, () => {

      let transferData = {
        diamonds: this.state.selectedJewelry,
        message_body: this.composeTransferMessage(),
        appointment_date: this.state.transferApptDate,
      }

      this.props.messagesSendTransferReq(transferData)
      .then((respData) => {
        this.uncheckAll();
      })
      // .catch((errorResp) => {
      //   console.error(errorResp);
      // });
    });
  }

  shareAll() {
    
    if(this.state.selectedJewelry.length === 0) {
      this.props.commonAlert('Please select at least one diamond');
      return;
    }

    // Make list of diamond objects
    let diamonds = [];
    for(let i = 0; i < this.state.selectedJewelry.length; i++) {
      for(let j = 0; j < this.props.jewelry.jewelryResults.length; j++) {
        if(this.props.jewelry.jewelryResults[j].sku === this.state.selectedJewelry[i]) {
          diamonds.push(this.props.jewelry.jewelryResults[j]);
          break;
        }
      }
    }
    this.props.leadsOpenShareDirectDropdown(diamonds, 'WATCH');
  }

  addToCustomerCard() {
    if(this.state.selectedJewelry.length === 0) {
      this.props.commonAlert('Please select at least one diamond');
      return;
    }

    // Make list of diamond objects
    let diamonds = [];
    for(let i = 0; i < this.state.selectedJewelry.length; i++) {
      for(let j = 0; j < this.props.jewelry.jewelryResults.length; j++) {
        if(this.props.jewelry.jewelryResults[j].id === this.state.selectedJewelry[i]) {
          diamonds.push(this.props.jewelry.jewelryResults[j]);
          break;
        }
      }
    }
    this.props.leadsOpenAddDropdown(diamonds);
  }

  addToExternalProfile() {

    if(this.state.selectedJewelry.length === 0) {
      this.props.commonAlert('Please select at least one diamond');
      return;
    }
    
    if(this.props.users.customerCard === null) {

      // Make list of diamond objects
      let diamonds = [];
      for(let i = 0; i < this.state.selectedJewelry.length; i++) {
        for(let j = 0; j < this.props.jewelry.jewelryResults.length; j++) {
          if(this.props.jewelry.jewelryResults[j].id === this.state.selectedJewelry[i]) {
            diamonds.push(this.props.jewelry.jewelryResults[j]);
            break;
          }
        }
      }

      this.props.usersAddToShareQueue(diamonds, window.location.pathname);
      this.userNav('customer-profile');
    } else {

      let addData = {
        card_id: this.props.users.customerCard.id,
        diamonds: this.state.selectedJewelry,
      }

      this.props.leadsAddDiamonds(addData)
      .then((respData) => {
        this.props.commonAlert('Diamonds added to your profile');
        this.setState({
          selectedJewelry: [],
        }, () => {
          this.props.jewelrySaveSelected(this.state.selectedJewelry);
        });
      })
      // .catch((errorResp) => {
      //   // console.error(errorResp);
      // });
    }
  }

  externalShareAll(diamonds) {
    if(this.props.users.customerCard === null) {
      this.props.usersAddToShareQueue(diamonds, window.location.pathname);
      this.userNav('customer-profile');
    } else {
      this.setState({ shareAllOpen: true });
    }
  }

  getShareCardId() {
    return this.props.users.customerCard ? this.props.users.customerCard.lookup_key : '';
  }

  getShareCardEmail() {
    return this.props.users.customerCard ? this.props.users.customerCard.email : '';
  }

  setLocations(location) {

    location = location.toString();

    if(location === 'All') {
      this.setState({ 
        locations: 'All', 
        sortByExtensionOpen: false,
      }, () => {
        this.addLocations();
      });
      return;
    }
    if(this.state.locations.toString().indexOf('All') > -1) {
      this.setState({ locations: location.toString() }, () => {
        this.addLocations();
      });
      return;
    }

    let clone = this.state.locations.toString().split(',');
    if(clone[0] === '') {
      clone = [];
    }

    let i = clone.indexOf(location);
    if(i === -1) {
      clone.push(location);
      this.setState({ locations: clone.join(',') }, () => {
        this.addLocations();
        return;
      });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ locations: 'All' }, () => {
          this.addLocations();
          return;
        });
      } else {
        this.setState({ locations: clone.join(',') }, () => {
          this.addLocations();
          return;
        });
      }
    }
  }

  isOnHold(diamond) {
    if(diamond.last_hold === null) {
      return false;
    }
    let holdTime = new Date(diamond.last_hold);
    let now = new Date();

    if((now - holdTime) <= holdConst.HOLD_DURATION) {
      return true;
    }
    return false;
  }

  changeTransferName(evt) {
    this.setState({ transferName: evt.target.value });
  }

  changeTransferApptDate(evt) {
    this.setState({ transferApptDate: evt.target.value });
  }

  changeTransferApptTime(evt) {
    this.setState({ transferApptTime: evt.target.value });
  }

  changeTransferBudget(evt) {
    this.setState({ transferBudget: evt.target.value });
  }

  changeTransferMessage(evt) {
    this.setState({ transferMessage: evt.target.value });
  }

  changeHoldMessage(evt) {
    this.setState({
      holdMessage: evt.target.value,
    });
  }

  closeTransferModal() {
    this.setState({ transferModalOpen: false });
  }

  closeHoldModal() {
    this.setState({ holdModalOpen: false });
  }

  composeTransferMessage() {
    let baseMessage = '';
    if(this.state.transferName !== '') {
      baseMessage = baseMessage + 'Customer name: ' + this.state.transferName + '\n';
    }
    if(this.state.transferApptDate !== '') {
      baseMessage = baseMessage + 'Appointment Date: ' + this.state.transferApptDate + '\n';
    }
    if(this.state.transferApptTime !== '') {
      baseMessage = baseMessage + 'Appointment Time: ' + this.state.transferApptTime + '\n';
    }
    if(this.state.transferBudget !== '') {
      baseMessage = baseMessage + 'Budget: ' + this.state.transferBudget + '\n';
    }
    if(this.state.transferMessage !== '') {
      baseMessage = baseMessage + 'Message: ' + this.state.transferMessage;
    }
    return baseMessage;
  }

  openShareInternal() {

    // Make list of diamond objects
    let diamonds = [];
    for(let i = 0; i < this.state.selectedJewelry.length; i++) {
      for(let j = 0; j < this.props.jewelry.jewelryResults.length; j++) {
        if(this.props.jewelry.jewelryResults[j].id === this.state.selectedJewelry[i]) {
          diamonds.push(this.props.jewelry.jewelryResults[j]);
          break;
        }
      }
    }
    this.props.messagesOpenNewDiamondDropdown(diamonds);
    this.setState({ shareModalOpen: false });
  }

  // Depricated; no longer called
  openShareExternal() {

    // Make list of diamond objects
    let diamonds = [];
    for(let i = 0; i < this.state.selectedJewelry.length; i++) {
      for(let j = 0; j < this.props.jewelry.jewelryResults.length; j++) {
        if(this.props.jewelry.jewelryResults[j].id === this.state.selectedJewelry[i]) {
          diamonds.push(this.props.jewelry.jewelryResults[j]);
          break;
        }
      }
    }
    this.props.leadsOpenShareDirectDropdown(diamonds, 'WATCH');
  }

  closeShareModal() {
    this.setState({ shareModalOpen: false });
  }

  addIndividualWatchToCard(watch) {

    if(this.props.users.customerCard === null) {
      return;
    }

    let addData = {
      card_id: this.props.users.customerCard.id,
      diamonds: [ watch.sku ],
    }

    this.props.leadsAddDiamonds(addData)
    .then((respData) => {
      // Do nothing
    })
    // .catch((errorResp) => {
    //   // console.error(errorResp);
    // });
  }

  addMultipleDiamondsToCard() {

    if(this.props.users.customerCard === null) {
      return;
    }

    let addData = {
      card_id: this.props.users.customerCard.id,
      diamonds: this.state.selectedJewelry,
    }

    this.props.leadsAddDiamonds(addData)
    .then((respData) => {

    })
    // .catch((errorResp) => {
    //   // console.error(errorResp);
    // });
  }

  getLocationCount(locationName) {

    let targetId = getLocationId(locationName);
    let isAll = locationName == 'All';

    if(!this.state.locationData) {
      return '';
    }

    let allCount = 0;
    for(let i = 0; i < this.state.locationData.length; i++) {
      if(this.state.locationData[i].location_num == targetId) {
        return '(' + this.state.locationData[i].count + ')';
      }
      if(isAll) {
        allCount += this.state.locationData[i].count;
      }
    }
    
    if(isAll) {
      return '(' + allCount + ')';
    }

    return '';
  }

  isLocationSelected(locationName) {

    let locationArray = this.state.locations.toString().split(',');
    if(locationArray[0] === '') {
      locationArray = [];
    }
    return locationArray.indexOf(getLocationId(locationName).toString()) > -1;
  }

  viewJewelry(jewelry) {
    this.props.jewelrySetLastPosition(this.props.common.currentScrollTop);
    this.userNav(`jewelry/view/${jewelry.sku}`);
  }

  hasLocationValue() {
    return true;
  }

  getDiamondImageUrl(diamond) {
    if(!diamond || !diamond.image) { return ''; }

    if(diamond.image.substring(0, 4) === 'http' || diamond.image.substring(0, 2) === '//') {
      return diamond.image;
    }
    return 'https://s3.amazonaws.com/inv-app-diamond-unprocessed-prod/' + diamond.image;
  }

  render() {

    // let base_url = window.location.protocol + '//' + location.hostname;
    let base_url = api.FRONTEND_URL;

    return <div className={isLoggedIn() ? 'JewelryResults loggedIn' : 'JewelryResults'}>
      <div className='resultsHeaderSpacer'></div>
      <div className={isLoggedIn() ? 'resultsHeader loggedInHeader' : 'resultsHeader'}>
        <div className='resultsHeaderWrapper'>Jewelry Results</div>
        

        <div className={isLoggedIn() ? 'controlsWrapper loggedIn' : 'controlsWrapper'}>
          <div className='lhsControls'>
            <div className='sortByWrapper' style={{ display: 'none' }}>
              <div 
                className='sortByLabel' 
                onClick={this.toggleSortByMenu.bind(this)} 
                ref={(sortByLabel) => { this.sortByLabel = sortByLabel; }}>
                Sort By:
                <div className={this.state.sortByOpen ? 'sortByMenu resultsMenu open' :  'sortByMenu resultsMenu'} ref={(sortByMenuBody) => { this.sortByMenuBody = sortByMenuBody; }}>
                  <div className='menuInnerWrapper'>
                    <div 
                      className={this.state.sortByDisplay == 'Price' ?  'menuEntry selected' : 'menuEntry'} 
                      onClick={() => this.selectSort('Price')}>
                      <div className='selectCheck'><i className="fas fa-check"></i></div>Price
                    </div>
                  </div>
                </div>
              </div>
              {this.state.sortByDisplay ?
                <div 
                  className='sortByDisplay' 
                  onClick={this.toggleSortByMenu.bind(this)} 
                  ref={(sortByDisplay) => { this.sortByDisplay = sortByDisplay; }}>{this.state.sortByDisplay}</div> :
                null
              }
              <div 
                className='sortByArrow' 
                onClick={this.toggleSortArrow.bind(this)} 
                ref={(sortByArrow) => { this.sortByArrow = sortByArrow; }}>
                <img src='/img/results/arrow.svg' />
              </div>
              {this.state.sortByDisplay == 'Location' || true ?
                <div 
                  className='sortByExtensionDisplay' 
                  style={{display: 'none'}}
                  ref={(sortByExtensionDisplay) => { this.sortByExtensionDisplay = sortByExtensionDisplay; }}>
                  {this.state.sortByExtensionDisplay ? 
                    this.state.sortByExtensionDisplay : 
                    <span onClick={this.toggleSortByExtensionMenu.bind(this)}>
                      {this.state.locations == 'All' ?
                        <span>All&nbsp;Locations</span> :
                        <span>Select&nbsp;Locations</span>
                      }
                    </span>
                  }
                  <div className={this.state.sortByExtensionOpen ? 'sortBySecondaryMenu resultsMenu open' : 'sortBySecondaryMenu resultsMenu'} ref={(sortByExtensionMenuBody) => { this.sortByExtensionMenuBody = sortByExtensionMenuBody; }}>
                    <div className='menuInnerWrapper'>
                      <div 
                        className={'menuEntry'}
                        onClick={this.toggleSortByExtensionMenu.bind(this)}>
                        <div className='selectClose'>&times;</div>
                        Close&nbsp;Locations
                      </div>
                      <div className='inlineLocations'>
                        <div 
                          className={this.state.locations.toString().split(',').indexOf('All') > -1 ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations('All')}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          All&nbsp;Locations<span className='locationCount'>{this.getLocationCount('All')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Atlanta') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Atlanta'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Atlanta<span className='locationCount'>{this.getLocationCount('Atlanta')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Austin') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Austin'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Austin<span className='locationCount'>{this.getLocationCount('Austin')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Baybrook') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Baybrook'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Baybrook<span className='locationCount'>{this.getLocationCount('Baybrook')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Birmingham') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Birmingham'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Birmingham<span className='locationCount'>{this.getLocationCount('Birmingham')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Boca Raton') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Boca Raton'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Boca Raton<span className='locationCount'>{this.getLocationCount('Boca Raton')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Charleston') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Charleston'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Charleston<span className='locationCount'>{this.getLocationCount('Charleston')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Charlotte') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Charlotte'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Charlotte<span className='locationCount'>{this.getLocationCount('Charlotte')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Cleveland') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Cleveland'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Cleveland<span className='locationCount'>{this.getLocationCount('Cleveland')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Columbus') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Columbus'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Columbus<span className='locationCount'>{this.getLocationCount('Columbus')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Dallas') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Dallas'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Dallas<span className='locationCount'>{this.getLocationCount('Dallas')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Troy') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Troy'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Troy<span className='locationCount'>{this.getLocationCount('Troy')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Frisco') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Frisco'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Frisco<span className='locationCount'>{this.getLocationCount('Frisco')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Greenville') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Greenville'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Greenville<span className='locationCount'>{this.getLocationCount('Greenville')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Houston') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Houston'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Houston<span className='locationCount'>{this.getLocationCount('Houston')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Indianapolis') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Indianapolis'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Indianapolis<span className='locationCount'>{this.getLocationCount('Indianapolis')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Jacksonville') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Jacksonville'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Jacksonville<span className='locationCount'>{this.getLocationCount('Jacksonville')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Kansas City') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Kansas City'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Kansas&nbsp;City<span className='locationCount'>{this.getLocationCount('Kansas City')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('New Orleans') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('New Orleans'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          New Orleans<span className='locationCount'>{this.getLocationCount('New Orleans')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Oklahoma City') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Oklahoma City'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Oklahoma&nbsp;City<span className='locationCount'>{this.getLocationCount('Oklahoma City')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Orlando') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Orlando'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Orlando<span className='locationCount'>{this.getLocationCount('Orlando')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Palm Beach') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Palm Beach'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Palm Beach<span className='locationCount'>{this.getLocationCount('Palm Beach')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Pittsburgh') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Pittsburgh'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Pittsburgh<span className='locationCount'>{this.getLocationCount('Pittsburgh')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Raleigh') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Raleigh'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Raleigh<span className='locationCount'>{this.getLocationCount('Raleigh')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Richmond') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Richmond'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Richmond<span className='locationCount'>{this.getLocationCount('Richmond')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('St. Louis') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('St. Louis'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          St.&nbsp;Louis<span className='locationCount'>{this.getLocationCount('St. Louis')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('San Antonio') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('San Antonio'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          San&nbsp;Antonio<span className='locationCount'>{this.getLocationCount('San Antonio')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Schaumburg') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Schaumburg'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Schaumburg<span className='locationCount'>{this.getLocationCount('Schaumburg')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Tysons') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Tysons'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Tysons<span className='locationCount'>{this.getLocationCount('Tysons')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Virginia Beach') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Virginia Beach'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Virginia&nbsp;Beach<span className='locationCount'>{this.getLocationCount('Virginia Beach')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Woodlands') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Woodlands'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Woodlands<span className='locationCount'>{this.getLocationCount('Woodlands')}</span>
                        </div>
                      </div>
                      <div 
                        className={'menuEntry'}
                        onClick={this.toggleSortByExtensionMenu.bind(this)}
                        style={{paddingBottom: '45px'}}>
                        <div className='selectClose'>&times;</div>
                        Close&nbsp;Locations
                      </div>
                    </div>
                  </div>
                </div> :
                null
              }
              
              <div className='resetFilters' onClick={this.resetFilters.bind(this)}>Reset</div>
            </div>
          </div>
          <div className='rhsControls'>
            <div className='actionsWrapper'>
              
              <div className='actionsArrow' onClick={this.toggleActionsMenu.bind(this)} ref={(actionsArrow) => { this.actionsArrow = actionsArrow; }}>
                <img src='/img/results/arrow.svg' />
                <div className={this.state.actionsOpen ? 'actionsMenu resultsMenu open' : 'actionsMenu resultsMenu'} ref={(actionsMenuBody) => { this.actionsMenuBody = actionsMenuBody; }}>
                  <div className='menuInnerWrapper'>
                    <div 
                      className={this.state.showOnlySelected ? 'menuEntry selected' : 'menuEntry'} 
                      onClick={this.toggleShowOnlySelected.bind(this)}>
                      <div className='selectCheck'><i className="fas fa-check"></i></div>Show&nbsp;Only&nbsp;Selected</div>
                    {isLoggedIn() ?
                      <div>
                        <div className='menuEntry' style={{ display: 'none' }} onClick={this.transferAll.bind(this)}>Transfer&nbsp;All</div>
                        <div className='menuEntry' style={{ display: 'none' }} onClick={this.holdAll.bind(this)}>Hold&nbsp;All</div>
                        {(isGM() || isSA()) && false ?
                          <div className='menuEntry' onClick={this.addToCustomerCard.bind(this)}>Add&nbsp;to&nbsp;Customer&nbsp;Card</div> :
                          null
                        }
                      </div> :
                      <div className='menuEntry' onClick={this.addToExternalProfile.bind(this)}>Add&nbsp;to&nbsp;My&nbsp;Profile</div>
                    }
                    <div className='menuEntry' onClick={this.uncheckAll.bind(this)}>Uncheck&nbsp;All</div>
                  </div>
                </div>
              </div>
              <div className='actionsLabel' onClick={this.toggleActionsMenu.bind(this)} ref={(actionsLabel) => { this.actionsLabel = actionsLabel; }}>Actions</div>
              <div className='editSearchHeaderWrapper' onClick={this.editNav.bind(this)}>
                Edit Search
              </div>
            </div>
          </div>
          <div className='centerToggle' onClick={this.props.jewelryToggleListView.bind(this)} style={{ display: 'none' }}>
            {this.props.jewelry.resultsList ?
              <div>Show detail view</div> :
              <div>Show list view</div>
            }
          </div>
        </div>




      </div>
      {this.state.resultsBlocked ?
        <div className='loginPrompt'>Please <span className='loginLink' onClick={() => this.userNav('login')}>login</span> to see results</div> :
        <div>
          

          <div className='shareAllBlock' style={{maxHeight: this.state.shareAllOpen ? '200px' : '0'}}>
            <div className='shareAllWrapper'>
              <div className='shareAllTitle'>Share All</div>
              <div className='shareAllIconWrapper' onClick={this.addMultipleDiamondsToCard.bind(this)}>
                <a href={'mailto:' + this.getShareCardEmail() + '?subject=' + encodeURIComponent('My timepiece collection') + '&body=' + encodeURIComponent('Check out the diamond collection I have shared! ' + base_url + '/shared-collection/' + this.getShareCardId())}>
                  <div className='shareIcon'>
                    <img src='/img/icons/share/email.svg' />
                  </div>
                </a>
                <a href={'https://www.facebook.com/sharer/sharer.php?u=' + base_url + '/shared-collection/' + this.getShareCardId()} target="_blank" style={{display: 'none'}}>
                  <div className='shareIcon'>
                    <img src='/img/icons/share/facebook.svg' />
                  </div>
                </a>
                <a href={'https://api.whatsapp.com/send?text=' + encodeURIComponent('Check out the timepiece collection I have shared!! ' + base_url + '/shared-collection/' + this.getShareCardId())} target="_blank">
                  <div className='shareIcon'>
                    <img src='/img/icons/share/whatsapp.svg' />
                  </div>
                </a>
                <a href={'sms:?body=' + encodeURIComponent('Check out the timepiece collection I have shared!! ' + base_url + '/shared-collection/' + this.getShareCardId())}>
                  <div className='shareIcon'>
                    <img src='/img/icons/share/text.svg' />
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className={this.props.jewelry.resultsList ? 'resultsWrapper listView' : 'resultsWrapper blockView'} ref={(div) => { this.resultsWrapper = div; }}>
            {this.state.requestPending ?
              <div className='loadingDiamonds'>
                <RhinoLoading message='Loading jewelry' />
              </div> :
              <div>
                {this.props.jewelry.jewelryResultsCount === 1 ?
                  <div className='foundLabel'>{'Found ' + this.props.jewelry.jewelryResultsCount + ' piece'}</div> :
                  <div className='foundLabel'>{'Found ' + formatNumber(this.props.jewelry.jewelryResultsCount) + ' pieces'}</div>
                }
                <div className='editSearchWrapper' onClick={this.editNav.bind(this)}>
                  Edit Search
                </div>
                {this.props.jewelry.jewelryResults.length === 0 ?
                  <div className='nullResults'>
                    No jewelry matching your search parameters
                  </div> :
                  <div>
                    {this.props.jewelry.resultsList ?
                      <div className='listViewWrapper'>
                        <div className='listViewHeader listDiamondEntry'>
                          <div className='selectCell headerCell'></div>
                          <div className='skuCell headerCell'>SKU</div>
                          <div className='nameCell headerCell'>Description</div>
                          <div className='priceCell headerCell'>Price</div>
                          <div className='jewelryTypeCell headerCell'>Type</div>
                          <div className='actionCell headerCell'>Action</div>
                        </div>
                        <div className='listViewBody'>
                          {this.props.jewelry.jewelryResults.map((jewelry, i) => {

                            if(!jewelry) {
                              return null;
                            }

                            if(this.state.showOnlySelected && !this.isSelected(jewelry)) {
                              return null;
                            }

                            return <div className={this.isSelected(jewelry) ? 'listDiamondEntry selected' : 'listDiamondEntry'} key={i}>
                              <div className='selectCell entryCell'>
                                <div className={this.isSelected(jewelry) ? 'favoriteWrapper favoriteSelected' : 'favoriteWrapper'} onClick={() => this.toggleSelected(jewelry)}>
                                  <img src='/img/diamonds/star.svg' className='notSelectedStar' />
                                  <img src='/img/diamonds/star_fill.svg' className='selectedStar' />
                                </div>
                              </div>
                              <div className='skuCell entryCell' onClick={() => this.viewJewelry(jewelry)}>{jewelry.sku}</div>
                              <div className='nameCell entryCell' onClick={() => this.viewJewelry(jewelry)}>{jewelry.name}</div>
                              <div className={'priceCell entryCell'} onClick={() => this.viewJewelry(jewelry)}>{formatPrice(jewelry)}<span className={this.props.auth.hideData ? 'costWrapper costHidden' : 'costWrapper'}>{this.getCost(jewelry)}</span></div>
                              <div className='jewelryTypeCell entryCell' onClick={() => this.viewJewelry(jewelry)}>{formatJewelryType(jewelry)}</div>
                              <div className='actionCell entryCell' onClick={() => this.viewJewelry(jewelry)}>View</div>
                            </div>;
                          })}
                        </div>
                      </div> :
                      <div className='blockViewWrapper'>
                        {this.props.jewelry.jewelryResults.map((jewelry, i) => {

                          if(this.state.showOnlySelected && !this.isSelected(jewelry)) {
                            return null;
                          }

                          return <div className='diamondEntry' key={i}>
                            <div className={this.isSelected(jewelry) ? 'entryInnerWrapper selected' : 'entryInnerWrapper'}>
                              <div className='diamondControlsWrapper'>
                                <div className={this.isSelected(jewelry) ? 'favoriteWrapper favoriteSelected' : 'favoriteWrapper'} onClick={() => this.toggleSelected(jewelry)}>
                                  <img src='/img/diamonds/star.svg' className='notSelectedStar' />
                                  <img src='/img/diamonds/star_fill.svg' className='selectedStar' />
                                </div>
                              </div>
                              <div className='imageWrapper' onClick={() => this.viewJewelry(jewelry)}>
                                {jewelry.img1 ?
                                  <img src={'https://watchimg.diamondsdirect.com/' + jewelry.img1} /> :
                                  <img src={this.getDefaultImage(jewelry)} />
                                }
                              </div>
                              <div className='entryBody'>
                                <div className='entryHeader'>
                                  <div className='headerTitle'>
                                    <div className={'titleWrapper EllipsisElement'}>{jewelry.description}</div>
                                    <div className={'priceWrapper'}>{formatPrice(jewelry)}<span className={this.props.auth.hideData ? 'costWrapper costHidden' : 'costWrapper'}>{this.getCost(jewelry)}</span></div>
                                    <div className='locationWrapper' style={{ display: 'none' }}>
                                      <div className='locationIcon'>
                                        <i className="fas fa-map-marker-alt"></i>
                                      </div>
                                      <div className='locationValue'>
                                        {formatLocation(jewelry)}
                                      </div>
                                      {isLoggedIn() && this.isOnHold(jewelry) ?
                                        <div className='locationHold'>
                                          On Hold
                                        </div> :
                                        null
                                      }
                                      {isLoggedIn() && !this.isOnHold(jewelry) ?
                                        <div className={this.props.auth.hideData ? 'locationCost costHidden' : 'locationCost'}>
                                          {this.getCost(jewelry)}
                                        </div> :
                                        null
                                      }
                                    </div>
                                  </div>
                                  <div className='headerButtons'>
                                    <div className={'viewButton secondaryButton'} onClick={() => this.viewJewelry(jewelry)}>View</div>
                                    <div 
                                      className={'shareButton secondaryButton'} 
                                      onClick={() => this.shareWatch(jewelry)}>
                                      Share
                                    </div>
                                    <div className='shareDrawer' style={{maxHeight: this.individualShareOpen(jewelry) ? '150px' : '0'}}>
                                      <div className='shareIconWrapper' onClick={() => this.addIndividualDiamondToCard(jewelry)}>
                                        <a href={'mailto:' + this.getShareCardEmail() + '?subject=' + encodeURIComponent('My timepiece collection') + '&body=' + encodeURIComponent('Check out the timepiece collection I have shared!! ' + base_url + '/shared-collection/' + this.getShareCardId())}>
                                          <div className='shareIcon'>
                                            <img src='/img/icons/share/email.svg' />
                                          </div>
                                        </a>
                                        <a href={'https://www.facebook.com/sharer/sharer.php?u=' + base_url + '/shared-collection/' + this.getShareCardId()} target="_blank" style={{display: 'none'}}>
                                          <div className='shareIcon'>
                                            <img src='/img/icons/share/facebook.svg' />
                                          </div>
                                        </a>
                                        <a href={'https://api.whatsapp.com/send?text=' + encodeURIComponent('Check out the timepiece I have shared!! ' + base_url + '/shared-collection/' + this.getShareCardId())} target="_blank">
                                          <div className='shareIcon'>
                                            <img src='/img/icons/share/whatsapp.svg' />
                                          </div>
                                        </a>
                                        <a href={'sms:?body=' + encodeURIComponent('Check out the timepiece I have shared!! ' + base_url + '/shared-collection/' + this.getShareCardId())}>
                                          <div className='shareIcon'>
                                            <img src='/img/icons/share/text.svg' />
                                          </div>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className='entryDetails'>
                                  <div className='detailsTopLine'>
                                    <div className='measurementsWrapper' style={{ display: 'none' }}>{jewelry.group}</div>
                                    <div className='verticalSeparator' style={{ display: 'none' }}>|</div>
                                    <div className='skuWrapper'>{jewelry.sku}</div>
                                  </div>
                                  <div className='detailsBody'>
                                    <div className={'detailColumn firstColumn'}>
                                      {jewelry.movement ?
                                        <div className='detailEntry'>
                                          <div className='detailLabel'>Movement:</div>
                                          <div className='detailValue'>{jewelry.movement}</div>
                                        </div> :
                                        null
                                      }
                                      {jewelry.crystal ?
                                        <div className='detailEntry'>
                                          <div className='detailLabel'>Crystal Type:</div>
                                          <div className='detailValue'>{jewelry.crystal}</div>
                                        </div> :
                                        null
                                      }
                                      {jewelry.dial_color ?
                                        <div className='detailEntry'>
                                          <div className='detailLabel'>Dial Color:</div>
                                          <div className='detailValue'>{jewelry.dial_color}</div>
                                        </div> :
                                        null
                                      }
                                    </div>
                                    <div className={'detailColumn secondColumn'}>
                                      {jewelry.case_material ?
                                        <div className='detailEntry'>
                                          <div className='detailLabel'>Case Material:</div>
                                          <div className='detailValue'>{jewelry.case_material}</div>
                                        </div> :
                                        null
                                      }
                                      {parseFloat(jewelry.case_size) ?
                                        <div className='detailEntry'>
                                          <div className='detailLabel'>Case Size:</div>
                                          <div className='detailValue'>{jewelry.case_size}</div>
                                        </div> :
                                        null
                                      }
                                      {jewelry.band_material ?
                                        <div className='detailEntry'>
                                          <div className='detailLabel'>Band Material:</div>
                                          <div className='detailValue'>{jewelry.band_material}</div>
                                        </div> :
                                        null
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>;
                        })}
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
      {this.props.jewelry.jewelryResults !== null ?
        <div>
          <div className={'searchSubmit bottomAction alwaysBottom'} onClick={this.watchesNav.bind(this)}>
            New Search
          </div>
          <div className='bottomActionSpacer alwaysBottom'></div>
        </div> :
        null
      }
      <RhinoModal
        open={this.state.holdModalOpen}>
        <div className='transferModal'>
        <div className='closeModal' onClick={this.closeHoldModal.bind(this)}>&times;</div>
          <div className='transferModalTitle'>Submit Hold Request</div>
          <div className='transferModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          <div className='transferModalInput'>
            <textarea
              type='text' 
              onChange={this.changeHoldMessage.bind(this)} 
              value={this.state.holdMessage}
              placeholder='Include an optional message'></textarea>
          </div>
          <div className='transferModalButton'>
            <button className={'actionButton transferButton'} onClick={this.sendHoldRequest.bind(this)}>Submit Request</button>
          </div>
        </div>
      </RhinoModal>
      <RhinoModal
        open={this.state.transferModalOpen}>
        <div className='transferModal'>
        <div className='closeModal' onClick={this.closeTransferModal.bind(this)}>&times;</div>
          <div className='transferModalTitle'>Submit Transfer Request</div>
          <div className='transferModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferName.bind(this)}
              value={this.state.transferName}
              placeholder='Customer Name' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              className={this.state.transferApptDateError ? 'error' : ''}
              onChange={this.changeTransferApptDate.bind(this)}
              value={this.state.transferApptDate}
              placeholder='Appointment Date' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferApptTime.bind(this)}
              value={this.state.transferApptTime}
              placeholder='Appointment Time' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferBudget.bind(this)}
              value={this.state.transferBudget}
              placeholder='Estimated Budget' />
          </div>
          <div className='transferModalInput'>
            <textarea
              type='text' 
              onChange={this.changeTransferMessage.bind(this)}
              value={this.state.transferMessage}
              placeholder='Include an optional message'></textarea>
          </div>
          <div className='transferModalButton'>
            <button className={'actionButton transferButton'} onClick={this.sendTransferRequest.bind(this)}>Submit Request</button>
          </div>
        </div>
      </RhinoModal>
      <RhinoModal
        open={this.state.shareModalOpen && false}>
        <div className='shareModal'>
          <div className='closeModal' onClick={this.closeShareModal.bind(this)}>&times;</div>
          <div className='shareModalTitle'>Who would you like to share with?</div>
          <div className='shareModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          <div className='shareModalButtons'>
            <button className={'actionButton shareButton'} onClick={this.openShareInternal.bind(this)}>Employees</button>
            <button className={'actionButton shareButton'} onClick={this.openShareExternal.bind(this)}>Customers</button>
          </div>
        </div>
      </RhinoModal>
    </div>;
  }
}
export default JewelryResults;

function mapStateToProps(state) {
  return {
    auth: state.auth,
    common: state.common,
    users: state.users,
    jewelry: state.jewelry,
  };
}

export const JewelryResultsContainer = connect(
  mapStateToProps,
  allActionCreators
)(JewelryResults);